const listeners = new Set();

export function publishNotification(message, severity = 'info') {
  listeners.forEach((listener) => listener(message, severity));
}

export function subscribeToNotifications(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
